import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UserNotificationsModule } from "../user-notifications/user-notifications.component.module";
import { UserNavSettingsModule } from "../user-nav-settings/user-nav-settings.component.module";
import { NewLabComponent } from "./new-lab.component";
import { CreateLabModule } from "../create-lab/create-lab.component.module";
import { CloneLabModule } from "../clone-lab/clone-lab.component.module";
import { QuickJoinLabModule } from "../quick-join-lab/quick-join-lab.component.module";

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MaterialModule,
    SharedModule,
    UserNotificationsModule,
    UserNavSettingsModule,
    CreateLabModule,
    CloneLabModule,
    QuickJoinLabModule
],
    declarations: [NewLabComponent],
    exports: [NewLabComponent]
})
export class NewLabModule {}